// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"3ed08f7d","318":"8b427d01","319":"4ba2d5c9","360":"d3061cf2","364":"e1a1e179","395":"13295be4","453":"4e6304e9","592":"fd8631e9","614":"c6d8e7e1","667":"1fd2020d"}[chunkId] + ".chunk.js";
};